const context = require['context']('./', true, /\.(png)$/);
const files: {
  [key: string]: any;
} = {};

context.keys().forEach((filename) => {
  files[filename.replace('./', '').replace(/\.(png)/, '')] = context(filename);
});

export default files;
